import { queryOptions } from '@tanstack/react-query';
import { fetchPlanet, fetchPlanets } from '../api/planets';
import { QUERY_KEYS, STALE_TIMES } from '../../utils/constants';

/**
 * Query options factory for the planets list.
 * Reusable in useQuery, prefetchQuery, ensureQueryData, etc.
 */
export const planetsQueryOptions = () =>
  queryOptions({
    queryKey: QUERY_KEYS.planets,
    queryFn: fetchPlanets,
    staleTime: STALE_TIMES.planets,
  });

/**
 * Query options factory for a single planet by ID.
 */
export const planetQueryOptions = (id: string) =>
  queryOptions({
    queryKey: QUERY_KEYS.planet(id),
    queryFn: () => fetchPlanet(id),
    staleTime: STALE_TIMES.planets,
    enabled: !!id,
  });
